function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.75 1.75a2 2 0 00-2 2v18.5a2 2 0 002 2h24.5a2 2 0 002-2V3.75a2 2 0 00-2-2H3.75z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M8.75 29c0-.69.56-1.25 1.25-1.25h12a1.25 1.25 0 110 2.5H10c-.69 0-1.25-.56-1.25-1.25z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4 8.8a1.8 1.8 0 111.545 1.782l-5.347 5.57a1.55 1.55 0 01-2.236 0L13.6 14.315l-3.03 3.156a1.8 1.8 0 11-1.515-1.454l3.427-3.57a1.55 1.55 0 012.236 0l1.762 1.836 4.95-5.156a1.807 1.807 0 01-.03-.328z",
  fill: "url(#monitoring_svg__paint0)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "monitoring_svg__paint0",
  x1: 10.375,
  y1: 7,
  x2: 23.729,
  y2: 11.363,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgMonitoring = function SvgMonitoring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgMonitoring;